module.exports = __webpack_public_path__ + "static/media/invite1.410d03d8.svg";